import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableColumn } from '../../../core/models/table-column';
import { TextKeys } from '../../../core/i18n/text-keys';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-column-select-modal',
  templateUrl: './column-selection-list.component.html',
  styleUrls: ['./column-selection-list.component.scss'],
})
export class ColumnSelectionListComponent implements OnInit {
  @Input() columnsSelection: TableColumn[];

  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter<TableColumn[]>();

  tableColumns: string[];
  list: TableColumn[] = [];
  list$ = new BehaviorSubject<TableColumn[]>(this.list);
  oneSelected$: Observable<boolean>;

  texts = TextKeys;

  public newSelection: TableColumn[] = [];

  constructor() {}

  ngOnInit() {
    this.columnsSelection.forEach((row) => {
      this.list.push(Object.assign({} as TableColumn, row));
    });
    this.list$.next(this.list);
    this.oneSelected$ = this.list$.pipe(
      map((list) => !!list.find((rows) => rows.selected == true))
    );
  }

  onSelection(index: number) {
    this.list[index].selected = !this.list[index].selected;
    this.list$.next(this.list);
  }

  onToggleAll() {
    this.oneSelected$
      .subscribe((value) => {
        this.list.forEach((row) => {
          if (!row.disabled) {
            row.selected = !value;
          }
        });

        // if (value) {
        //     this.list.forEach(row => {
        //         if(!row.disabled){
        //             row.selected = false
        //         }
        //     });
        // } else {
        //     this.list.forEach(row => {
        //         if(!row.disabled){
        //             row.selected = true
        //         }
        //     });
        // }
      })
      .unsubscribe();
    this.list$.next(this.list);
  }

  handleOnCancel() {
    this.onCancel.emit();
  }

  handleOnSave() {
    // when nothing is selected select all.
    if (!this.list.find((item) => item.selected == true)) {
      this.list.forEach((item) => (item.selected = true));
    }
    this.onSave.emit(this.list);
  }

  drop(event: CdkDragDrop<TableColumn[]>) {
    moveItemInArray(this.list, event.previousIndex, event.currentIndex);
    this.list$.next(this.list);
  }
}
